var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solana"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.688 11.1701C28.501 11.342 28.2573 11.4386 28.0033 11.4413L3.96621 11.4413C3.11313 11.4413 2.68221 10.4658 3.2728 9.89486L7.22103 6.08882C7.40452 5.91166 7.64845 5.8108 7.90348 5.80664L32.0348 5.80664C32.8965 5.80664 33.3188 6.79097 32.7194 7.36406L28.688 11.1701Z",
    fill: "url(#paint0_linear_6265_325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.688 29.9305C28.4998 30.0991 28.2559 30.1925 28.0033 30.193H3.96621C3.11313 30.193 2.68221 29.2261 3.2728 28.6552L7.22103 24.8383C7.405 24.6632 7.64953 24.5659 7.90348 24.5669H32.0348C32.8965 24.5669 33.3188 25.5425 32.7194 26.1134L28.688 29.9305Z",
    fill: "url(#paint1_linear_6265_325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.688 15.4544C28.4998 15.2858 28.2559 15.1923 28.0033 15.1919L3.96621 15.1919C3.11313 15.1919 2.68221 16.1588 3.2728 16.7297L7.22103 20.5466C7.40737 20.7179 7.65036 20.8146 7.90348 20.8179H32.0348C32.8965 20.8179 33.3188 19.8423 32.7194 19.2714L28.688 15.4544Z",
    fill: "url(#paint2_linear_6265_325)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6265_325",
    x1: 3.00157,
    y1: 89.7341,
    x2: 33.7647,
    y2: 89.4521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47F8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6265_325",
    x1: 3.00157,
    y1: 13.279,
    x2: 33.5691,
    y2: 13.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6265_325",
    x1: 4.72741,
    y1: 18.0048,
    x2: 31.8378,
    y2: 18.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DCDC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.e782519b9c2bf3f49144a21c43ed9b99.svg";
export { ForwardRef as ReactComponent };